import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import cx from "classnames";
import useCreditProfileStore from "../../zustandStores/userCreditProfileStore";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import { Routes } from "../../routes/RouteConstants";
import LogService from "../../services/LogService";
import { isSaleActive } from "../../services/utils";
import classes from "./promotionBanner.module.css";
import UserService from "../../services/UserService";

const PromotionBanner = ({
  source = "",
  campaignType = "Christmas and New Year Offers",
  customClass = null
}) => {
  const router = useRouter();
  const deviceType = useSelector(state => state.commonReducer.deviceType);
  const isMobile = deviceType === "mobile";
  const recAccessToken = UserService.getAccessToken();

  const { isCreditBetaUser } = useCreditProfileStore(state => ({
    isCreditBetaUser: state.isCreditBetaUser
  }));
  const isPlanSelectionPage = source === "PLAN_SELECTION";
  let imgHeight = isMobile ? 48 : 56;
  let bannerImage = isPlanSelectionPage
    ? "christmas-plan-page-banner-desktop.svg"
    : "christmas-banner-desktop.svg";
  let bannerClassName = classes.bannerImg;
  if (isMobile) {
    bannerImage = isPlanSelectionPage
      ? "christmas-plan-page-banner-mobile.svg"
      : "christmas-banner-mobile.svg";
  }
  if (source === "CMPCARD") {
    bannerImage = isMobile
      ? "christmas-banner-cmpcard-mobile.png"
      : "christmas-banner-cmpcard-desktop.svg";
    imgHeight = isMobile ? 44 : 91;
    bannerClassName = classes.cardBannerImg;
  }
  if (!isSaleActive()) {
    return null;
  }
  if (recAccessToken && !isCreditBetaUser) {
    return null;
  }
  //const loginSource = ["LOGIN", "HOME"];
  const onBannerClick = () => {
    LogService.log(CREDIT_EVENTS.CAMPAIGN_BANNER_CLICKED, {
      source,
      campaign_type: campaignType
    });
    let url = `${Routes.PLAN_SELECTION}?eventSource=${source}`;

    // We always send ln landing page
    url = `${Routes.LANDING_PAGE}?ru=${Routes.PLAN_SELECTION}&eventSource=${source}`;

    // Check if the source matches "PLAN_SELECTION"
    if (isPlanSelectionPage) {
      return true;
    }
    // Check if the source matches any of the loginSource entries
    // if (loginSource.includes(source)) {
    //   url = `${Routes.LANDING_PAGE}?ru=${Routes.PLAN_SELECTION}&eventSource=${source}`;
    // }
    if (source === "LOGIN") {
      url = `${url}&purchaseHeader=true`;
    }
    router.push(url);
  };

  return (
    <div
      className={cx(
        classes.bannerContainer,
        isPlanSelectionPage ? classes.noClick : null,
        customClass
      )}
      onClick={onBannerClick}
    >
      <img
        src={`/hire/banner/${bannerImage}`}
        height={imgHeight}
        width={"100%"}
        alt="christmas-banner"
        className={bannerClassName}
      />
    </div>
  );
};
export default PromotionBanner;
